module.exports = __webpack_public_path__ + "img/CardNFT03.d52ece11.png";